import { IMessage } from '@stomp/stompjs';
import { WSMessage } from '../types';

export const toWSMessage = (originalMessage: IMessage): WSMessage => {
  const messageBody: WSMessage = JSON.parse(originalMessage.body);
  messageBody.id = originalMessage.headers['message-id'];
  return messageBody;
};
